import React, { useContext } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";

import ServiceTemplateItem from "./ServiceTemplateItem";

const ServiceTemplatesList = () => {
  const store = useContext(StoreContext);

  const itemType = "serviceTemplate";
  const listName = "main_serviceTemplates";

  const { serviceTemplates, InsertServiceTemplate, UpdateServiceTemplate, DeleteServiceTemplate } =
    useContext(StoreContext);

  const pageItems = serviceTemplates;

  let listColumns = [
    {
      field: "year",
      headerName: "Eğitim Yılı",
      width: 150,
      valueGetter: (params) =>
        store.educationYearsOptions.find((item) => item.value.toString() === params.row.year.toString()).label,
    },

    { field: "name", headerName: "Hizmet Adı", width: 300 },
    {
      field: "serviceStartDate",
      headerName: "Hizmet Başlangıç Tarihi",
      width: 200,
    },
    {
      field: "serviceEndingDate",
      headerName: "Hizmet Bitiş Tarihi",
      width: 200,
    },
    { field: "amount", headerName: "Meblağ", width: 200 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ServiceTemplateItem}
      NewItemComponent={ServiceTemplateItem}
      DeleteItem={DeleteServiceTemplate}
      InsertItem={InsertServiceTemplate}
      UpdateItem={UpdateServiceTemplate}
      hideCreateNewItemWhenSelected={true}
      showSelectedYear={true}
    />
  );
};

export default ServiceTemplatesList;
